import { FunctionComponent } from 'react';
import styled, { keyframes } from 'styled-components';

import { DefaultButtonStyled } from '@/components/atom/buttons/DefaultButton';

import Overlay from '../../Overlay';

export interface SelectModalProps {
  modalTitle: string;
  selectList: Array<SelectModalListItem>;
  onClose: () => void;
}

export interface SelectModalListItem {
  Icon: () => JSX.Element;
  text: string;
  onClick: () => void;
}

/**
 *
 * @param modalTitle string
 * @param selectList Array<SelectModalListItem>
 * @param onClose () => void
 */

const SelectModal: FunctionComponent<SelectModalProps> = ({ modalTitle, selectList, onClose }) => {
  return (
    <Overlay index={10} onClickOverlay={onClose}>
      <Container>
        <Title>{modalTitle}</Title>
        <SelectedItemWrapper>
          {selectList.map(({ Icon, text, onClick }, key) => (
            <SelectItem key={`selectModal_${key}`} onClick={onClick}>
              <Icon />
              <SelectItemText>{text}</SelectItemText>
            </SelectItem>
          ))}
        </SelectedItemWrapper>
      </Container>
    </Overlay>
  );
};

export default SelectModal;

const BottomUp = keyframes`
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
`;

const Container = styled.div`
  ${({ theme }) => `
  background: ${theme.color.white};
`};
  bottom: 32px;
  padding: 24px 0 16px;
  position: absolute;
  width: calc(100% - 32px);
  max-width: 736px;
  border-radius: 20px;
  animation: ${BottomUp} 0.3s;
`;

const Title = styled.div`
  ${({ theme }) => `
  ${theme.typography.UI20SB};
`};
  padding: 0 24px;
  margin-bottom: 8px;
`;

const SelectedItemWrapper = styled.div``;
const SelectItem = styled(DefaultButtonStyled)`
  width: 100%;
  justify-content: flex-start;
  padding: 12px 24px;

  ${({ theme }) => `
    &:active {
      opacity: 1;
      background-color: ${theme.color.gray50};
    }
  `}
`;

const SelectItemText = styled.span`
  margin-left: 16px;
`;
